import React from "react";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';
import history from '../../history';
import H2 from "@material-tailwind/react/Heading2";
import LeadText from '@material-tailwind/react/LeadText';
import H5 from "@material-tailwind/react/Heading5";

function Registration() {
    return (
      <div className="container max-w-8xl relative mx-auto"> 
        <Helmet>
            <title>The 7th International Conference on Soft Computing in Data Science 2023 (SCDS2023) - Copyright</title>
            <meta name="description" content="The 7th International Conference on Soft Computing in Data Science (SCDS) 2023 that will be held from 24 - 25 January 2023" />
            <meta name="keywords" content="registration, scds, scds2023, scds 2023, uitm, aaec, shah alam, conference" />
        </Helmet>   
        <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
            <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
            <li class="breadcrumb-item active" aria-current="page">Registration</li>
            </ol>
        </nav>

          <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center" >
                  <h1 color="dark">Registration & Invitation</h1>
                  <div style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
                    <p style={{ textAlign:'justify'}}>
                      Dear Tan Sri/Dato’ Sri/Professor/Associate Professor/Dr/Sir/Madam,<br/><br/>
                      Universiti Teknologi MARA, Malaysia & Baoji University of Arts and Sciences, Shaanxi, China cordially invite you to join SCDS2023 - The 7<sup>th </sup>  
                      International Conference on Soft Computing in Data Science virtual conference with the theme "Science in Analytics: Harnessing Data and Simplifying Solutions" 
                      on 24 - 25 January 2023.<br/><br/>

                      {/* Date: 2 November 2021 (Tuesday)<br/>
                      Time: 8.45 am – 5.00 pm MYT<br/>
                      Platform: ZOOM Webinar<br/><br/> */}

                      Use this link to register: <a href="https://edas.info/r29330" target="_blank" rel="noreferrer">https://edas.info/r29330</a><br/><br/>

                      Registration and payment latest by <b>20<sup>th</sup> November 2022.</b>

                      {/* Date: 3 November 2021 (Wednesday)<br/>
                      Time: 8.00 am – 6.00 pm MYT<br/>
                      Platform: ZOOM Webinar<br/><br/>

                      Click here to join: <a href="http://its.id/SCDS2021_day2" target="_blank" rel="noreferrer">http://its.id/SCDS2021_day2</a><br/><br/>

                      Link to SCDS2023 program schedule: <a style={{cursor:'pointer'}} onClick={() => history.push('/scds2023/programBook')}><b>Click here.</b></a><br/><br/> */}
                    </p>
                  </div>
                  
              </div>
          </div>

  </div>
    );
}

export default Registration;;